<template>
  <div class="manager-tabs">
    <div style="padding:0 12px;">
      <a-space :size="12" direction="vertical" style="width: 100%;">
        <a-button @click="doUpload" block type="primary">上传</a-button>
        <a-button @click="addFolder" block type="primary">创建子相册</a-button>
      </a-space>
      <UploadDrawer :album="album" :member="member" ref="uploadDrawer" @close="search"/>
    </div>
    <div :style="{height:height+'px'}" style="display: block;margin-top:12px;">
      <a-divider>子相册</a-divider>
      <FolderPane ref="folderPane" v-model="queryParams.folder_id" :album="album" :album-stats="albumStats"
                  @search="search"/>
      <a-divider>摄影师</a-divider>
      <MemberPane ref="memberPane" v-model="queryParams.member_id"
                  :album="album" :member="member" :album-stats="albumStats" @search="search"/>
    </div>
    <div style="margin:12px;">
      <a-button @click="cleanAll" block icon="delete" type="danger">清空相册</a-button>
      <CleanConfirm :album-id="album.id" @success="search()" ref="cleanConfirm"/>
    </div>
  </div>
</template>

<script>
import api from "../../../../../utils/api";
import MemberPane from "./MemberPane";
import FolderPane from "./FolderPane";
import StateMixin from "../../../../../comps/StateMixin";
import UploadDrawer from "../comps/UploadDrawer";
import CleanConfirm from "./CleanConfirm";

export default {
  name: "ManagerSider",
  mixins: [StateMixin],
  components: {CleanConfirm, UploadDrawer, FolderPane, MemberPane},
  props: {
    album: Object,
    member: Object,
    queryParams: Object,
  },
  data() {
    return {
      albumStats: {},
    }
  },
  computed: {
    height() {
      return this.$store.getters["layout/contentHeight"] - 205;
    }
  },
  async mounted() {
    this.albumStats = await api.v1.album.stats.album(this.album.id);
  },
  methods: {
    change(e) {
      this.$emit("change", e);
    },
    search(e) {
      this.$emit("search", e);
    },
    doUpload() {
      this.$refs.uploadDrawer.open();
    },
    addFolder() {
      this.$refs.folderPane.create();
    },
    cleanAll() {
      this.$refs.cleanConfirm.open();
    },
    async restats() {
      this.$refs.memberPane.restats();
      this.$refs.folderPane.restats();
      this.albumStats = await api.v1.album.stats.album(this.album.id);
    },
  }
}
</script>

<style lang="less">
.manager-tabs {
  padding-top: 15px;

  .ant-divider-horizontal.ant-divider-with-text-center {
    margin: 8px 0 2px 0;

    .ant-divider-inner-text {
      padding: 0 12px;
      font-size: 14px;
      font-weight: bold;
    }
  }
}
</style>